/**
 * AONA Wishlist Engine
 * assets/aona-wishlist.js
 */

(function () {
  'use strict';

  var STORAGE_KEY = 'aona_wishlist';

  function isCustomerLoggedIn() {
    if (window.aonaCustomerLoggedIn === true) return true;
    if (document.body && (document.body.classList.contains('customer-logged-in') || document.body.classList.contains('template-customers-account'))) return true;
    try {
      var fbUser = localStorage.getItem('aona_firebase_user');
      if (fbUser && JSON.parse(fbUser).uid) return true;
    } catch (e) {}
    try {
      var aonaUser = localStorage.getItem('aona_user_session');
      if (aonaUser && JSON.parse(aonaUser).isLoggedIn) return true;
    } catch (e) {}
    return false;
  }

  function getWishlist() {
    try {
      var data = localStorage.getItem(STORAGE_KEY);
      return data ? JSON.parse(data) : [];
    } catch (e) {
      console.error('Failed to parse wishlist', e);
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { wishlist: list } }));
    } catch (e) {
      console.error('Failed to save wishlist', e);
    }
  }

  function showSignInModal(customReturnPath) {
    var returnPath = customReturnPath || (window.location.pathname + window.location.search);
    var returnUrl = encodeURIComponent(returnPath);
    var loginUrl = '/account/login?return_to=' + returnUrl;
    var registerUrl = '/account/register?return_to=' + returnUrl;

    var modalEl = document.getElementById('aona-wishlist-auth-modal');
    if (!modalEl) {
      modalEl = document.createElement('div');
      modalEl.id = 'aona-wishlist-auth-modal';
      modalEl.className = 'aona-wishlist-modal-backdrop';
      modalEl.innerHTML = `
        <div class="aona-wishlist-modal-dialog" role="dialog" aria-modal="true" aria-labelledby="aona-wl-title">
          <button type="button" class="aona-wishlist-modal-close" aria-label="Close" onclick="window.aonaCloseWishlistModal()">&times;</button>
          <div class="aona-wishlist-modal-icon-wrap">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l8.78-8.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
            </svg>
          </div>
          <h3 class="aona-wishlist-modal-title" id="aona-wl-title">Sign In Required</h3>
          <p class="aona-wishlist-modal-desc">
            Please log in to your account to save your favorite luxury pieces to your personal wishlist and access them across all your devices.
          </p>
          <div class="aona-wishlist-modal-actions">
            <a href="${loginUrl}" class="aona-wishlist-modal-btn-primary" id="aona-wl-login-btn">SIGN IN TO CONTINUE</a>
            <a href="${registerUrl}" class="aona-wishlist-modal-btn-secondary" id="aona-wl-reg-btn">CREATE AN ACCOUNT</a>
          </div>
          <button type="button" class="aona-wishlist-modal-dismiss" onclick="window.aonaCloseWishlistModal()">Continue Browsing</button>
        </div>
      `;

      modalEl.addEventListener('click', function (e) {
        if (e.target === modalEl) {
          window.aonaCloseWishlistModal();
        }
      });

      document.body.appendChild(modalEl);
    } else {
      var loginBtn = document.getElementById('aona-wl-login-btn');
      var regBtn = document.getElementById('aona-wl-reg-btn');
      if (loginBtn) loginBtn.href = loginUrl;
      if (regBtn) regBtn.href = registerUrl;
    }

    // Force reflow and open
    setTimeout(function () {
      modalEl.classList.add('is-open');
    }, 10);
  }

  window.aonaCloseWishlistModal = function () {
    var modalEl = document.getElementById('aona-wishlist-auth-modal');
    if (modalEl) {
      modalEl.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  };

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      window.aonaCloseWishlistModal();
    }
  });

  var Wishlist = {
    add: function (handle) {
      if (!handle) return;
      var list = getWishlist();
      if (list.indexOf(handle) === -1) {
        list.push(handle);
        saveWishlist(list);
      }
    },

    remove: function (handle) {
      if (!handle) return;
      var list = getWishlist();
      var index = list.indexOf(handle);
      if (index !== -1) {
        list.splice(index, 1);
        saveWishlist(list);
      }
    },

    toggle: function (handle) {
      if (!handle) return false;
      if (this.has(handle)) {
        this.remove(handle);
        return false;
      } else {
        this.add(handle);
        return true;
      }
    },

    has: function (handle) {
      if (!handle) return false;
      return getWishlist().indexOf(handle) !== -1;
    },

    getAll: function () {
      return getWishlist();
    },

    clear: function () {
      saveWishlist([]);
    }
  };

  // Export globally
  window.aonaWishlist = Wishlist;
  window.aonaHandleWishlistClick = function (e, handle) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (!handle) return false;
    var btn = e ? (e.currentTarget || e.target.closest('[data-aona-wishlist-toggle], .pf-product-card__wishlist, .aona-wishlist-tag, .aona-pdp-wish-btn')) : null;
    var isActive = Wishlist.toggle(handle);
    if (btn) {
      btn.classList.toggle('active', isActive);
      btn.classList.toggle('is-active', isActive);
      btn.classList.toggle('is-wished', isActive);
    }
    return isActive;
  };

  // Global click delegator: Intercept ANY wishlist button click on the page
  document.addEventListener('click', function (e) {
    var target = e.target;
    var btn = target.closest('[data-aona-wishlist-toggle], .pf-product-card__wishlist, .aona-wishlist-tag, .aona-pdp-wish-btn, .wishlist-btn, .card__wishlist, [data-wishlist-toggle]');
    
    if (btn) {
      e.preventDefault();
      e.stopPropagation();

      var handle = btn.getAttribute('data-aona-wishlist-toggle') || btn.getAttribute('data-handle') || btn.getAttribute('data-product-handle');
      if (handle) {
        var isNowActive = Wishlist.toggle(handle);
        btn.classList.toggle('active', isNowActive);
        btn.classList.toggle('is-active', isNowActive);
        btn.classList.toggle('is-wished', isNowActive);
      }
    }
  }, true);

  // Initialize wishlist UI triggers on initial load & DOM changes
  function syncActiveStates() {
    var list = getWishlist();
    document.querySelectorAll('[data-aona-wishlist-toggle], .pf-product-card__wishlist, .aona-wishlist-tag, .aona-pdp-wish-btn').forEach(function (btn) {
      var handle = btn.getAttribute('data-aona-wishlist-toggle') || btn.getAttribute('data-handle') || btn.getAttribute('data-product-handle');
      if (handle && list.indexOf(handle) !== -1) {
        btn.classList.add('active', 'is-active', 'is-wished');
      } else if (handle) {
        btn.classList.remove('active', 'is-active', 'is-wished');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncActiveStates);
  } else {
    syncActiveStates();
  }

  document.addEventListener('wishlist:change', syncActiveStates);

  var observer = new MutationObserver(syncActiveStates);
  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
